import {
  ClientFragment,
  useCreateClientMutation,
} from "@graphql/clients/clients.g";

import {
  ClientForm,
  ClientFormValues,
} from "@components/Forms/ClientForm/ClientForm";

import { useFormErrorsAPI } from "@utils/hooks/useFormErrorsAPI";

type Props = {
  onCreateClientSuccess?: (data: ClientFragment) => Promise<void> | void;
};

export const CreateClientForm = ({ onCreateClientSuccess }: Props) => {
  const { errorsAPI, updateErrorsAPI } = useFormErrorsAPI();
  const createClientMutation = useCreateClientMutation();
  const createClient = createClientMutation.mutateAsync;

  const onSubmit = async (values: ClientFormValues) => {
    const data = await createClient({
      input: {
        ...values,
      },
    });

    const client = data.createClient?.client;
    const errors = data.createClient?.errors;

    if (errors) {
      updateErrorsAPI(errors);
    }

    if (!client) return;

    await onCreateClientSuccess?.(client);
  };

  return <ClientForm onSubmit={onSubmit} errorsAPI={errorsAPI} />;
};
